import React, { useEffect, useMemo, useState } from 'react';

import { PageHeader } from "../../shared/ui";
import ModalConfirm from '../../shared/ui/modal-confirm/ui/ModalConfirm';
import Filter from '../../shared/ui/filter/Filter';
import { getAdminReviews } from '../../shared/api/reviews.services';
import { matchesActiveStatus, matchesSearch, useListFilters } from '../../shared/lib/useListFilters';
import ReviewsList from '../../widgets/reviews-list/ui/ReviewsList';
import { useReviewsFilters } from '../../widgets/reviews-list/config/filter';

const SEARCH_FIELDS = ['author.name', 'author.subtitle', 'quote', 'id'];

const matchesMedia = (review, media) => {
  if (!media) return true;

  const wanted = String(media).split(',').filter(Boolean);
  if (wanted.length === 0) return true;

  const hasVideo = Boolean(review?.media?.url);

  return wanted.includes(hasVideo ? 'with' : 'without');
};

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const reviewsFilters = useReviewsFilters();
  const { query, get } = useListFilters();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getAdminReviews();
        setReviews(result?.items || []);
      } catch (error) {
        console.error("Помилка при завантаженні даних:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const status = get('status');
  const media = get('media');
  const visibleReviews = useMemo(
    () =>
      reviews.filter(
        (review) =>
          matchesSearch(review, query, SEARCH_FIELDS) &&
          matchesActiveStatus(review, status) &&
          matchesMedia(review, media)
      ),
    [reviews, query, status, media]
  );

  return (
    <>
      <ModalConfirm title="Ви впевнені, що хочете видалити цей відгук?" />

      <PageHeader
        placeholder={"Пошук за іменем або текстом відгуку"}
        createLink={"/review-rewrite/create"}
        filters={reviewsFilters}
      />
      <Filter fields={reviewsFilters} />

      <section className="section-admin">
        {loading ? (
          <p>Завантаження...</p>
        ) : (
          <ReviewsList
            data={{ items: visibleReviews, total: visibleReviews.length }}
            totalCount={reviews.length}
          />
        )}
      </section>
    </>
  );
}
